module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('Header', {
    staticClass: "black"
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "type"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      active: !_vm.type
    },
    on: {
      "click": function($event) {
        return _vm.onType(0)
      }
    }
  }, [_vm._v("雇主")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      active: _vm.type
    },
    on: {
      "click": function($event) {
        return _vm.onType(1)
      }
    }
  }, [_vm._v("制作人")])]), _vm._v(" "), _c('div', {
    staticClass: "state"
  }, [_c('a', {
    class: {
      active: _vm.state == 1
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.onState(1)
      }
    }
  }, [_vm._v("进行中")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.state == 2
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.onState(2)
      }
    }
  }, [_vm._v("已完成")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.state == 3
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.onState(3)
      }
    }
  }, [_vm._v("已关闭")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [((!_vm.type && !_vm.partyAList.length) || (_vm.type && !_vm.partyBList.length)) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无项目")]) : _vm._e(), _vm._v(" "), (!_vm.type) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.partyAList), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "order-no"
    }, [_vm._v("订单编号：" + _vm._s(item.projectNo)), _c('span', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v("项目名称：" + _vm._s(item.projectName))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info clearfix"
    }, [_c('div', [_c('div', [_vm._v("影片类型")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.typeStr))])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("要求成片时间")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("formatDate")(item.endTime)))])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("影片时长")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("length")(item.length)))])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("项目预算")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("budget")(item.budget)))])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("发布时间")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("formatDate")(item.addTime)))])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("项目状态")]), _vm._v(" "), (!(item.operatorStatus == 4 || item.isClosed)) ? _c('div', [_vm._v(_vm._s(_vm._f("ppaType")(item.status)))]) : _vm._e(), _vm._v(" "), (item.operatorStatus == 4 || item.isClosed) ? _c('div', [_vm._v("已关闭")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('a', {
      staticClass: "btn btn-default",
      attrs: {
        "href": 'projectPartyA.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_vm._v("查看详情")])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.type) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.partyBList), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "order-no"
    }, [_vm._v("订单编号：" + _vm._s(item.projectNo)), _c('span', {
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_vm._v("项目名称：" + _vm._s(item.projectName))])]), _vm._v(" "), _c('div', {
      staticClass: "order-info clearfix"
    }, [_c('div', [_c('div', [_vm._v("影片类型")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.typeStr))])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("要求成片时间")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("formatDate")(item.endTime)))])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("影片时长")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("length")(item.length)))])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("项目预算")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("budget")(item.budget)))])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("发布时间")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("formatDate")(item.addTime)))])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("项目状态")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.accessStatus))])]), _vm._v(" "), _c('div', [(item.status < 14) ? _c('a', {
      staticClass: "btn btn-default",
      attrs: {
        "href": 'projectAccept.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_vm._v("查看详情")]) : _vm._e(), _vm._v(" "), (item.status > 13) ? _c('a', {
      staticClass: "btn btn-default",
      attrs: {
        "href": 'projectPartyB.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_vm._v("查看详情")]) : _vm._e()])])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pages"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "page-size": _vm.pageSize,
      "current": _vm.currPage
    },
    on: {
      "on-change": _vm.pagesChange
    }
  })], 1)])]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c413bbe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/project/App.vue
// module id = 1268
// module chunks = 40